export default __webpack_public_path__ + "static/confirmation-ppq-modal-images-979262182f0cd0695b57ae4cd91b1cec.png";